































































































































































import Vue, { PropType } from 'vue'
import CreateDialog from '@/components/CreateDialog.vue'
import {
  Region,
  SubRegionCrud,
  Messenger,
  MessengerConfig,
} from '@/utils/interfaces'
import RegionDialog from './RegionDialog.vue'
import {
  createMessenger,
  messengerConfigController,
} from '@/api/Remittances/remittances.api'
import { number } from '@/utils/validators'
import MessengerSettings from './MessengerSettings.vue'
import Card from '@/components/Card.vue'
import {
  DeliveryCurrenciesEnum,
  DeliveryCurrency,
} from '~/utils/interfaces/remittance.interface'
import TextButton from '~/components/TextButton.vue'

export default Vue.extend({
  components: {
    appCreateDialog: CreateDialog,
    appRegionDialog: RegionDialog,
    appMessengerSettings: MessengerSettings,
    appCard: Card,
    TextButton,
  },
  props: {
    value: Boolean,
    item: Object as PropType<Messenger>,
  },
  data() {
    return {
      tabs: 0,
      fixed_commission: 0,
      rules: {
        number: (v: number | string) =>
          number((!v && v !== 0 ? '' : v).toString()) ||
          this.$t('must-be-a-number'),
        greaterThan: (v: number) => v >= 0 || this.$t('must-be-non-negative'),
      },
      loading: false,
      loadingConfig: false,
      regionDialog: false,
      regions: [] as Region[],
      crud: {
        agent: '',
        prepaid: false,
        commission_currency: 'CUP' as DeliveryCurrency,
        priority: 1,
        is_active: true,
        subregion_commissions: [] as SubRegionCrud[],
        delivery_currency: 'CUP' as DeliveryCurrency,
      } as MessengerConfig,
      defaultCrud: {
        agent: '',
        prepaid: false,
        commission_currency: 'CUP' as DeliveryCurrency,
        priority: 1,
        is_active: true,
        subregion_commissions: [] as SubRegionCrud[],
        delivery_currency: 'CUP' as DeliveryCurrency,
      } as MessengerConfig,
      deliveryCurrencies: Object.keys(
        DeliveryCurrenciesEnum,
      ) as DeliveryCurrency[],
      mounted: false,
    }
  },
  methods: {
    async onSave() {
      this.loading = true
      try {
        const data = [] as SubRegionCrud[]
        const subregions = this.$refs.subregion as (Vue & {
          getData: () => SubRegionCrud[]
        })[]
        if (subregions) {
          subregions.forEach(subregion => {
            subregion.getData().forEach(item => {
              data.push(item)
            })
          })
        }
        const payload = this.crud
        if (!payload.agent) payload.agent = this.item.uuid
        payload.subregion_commissions = data

        const response = await createMessenger(payload)
        const item = this.item
        item.messenger_configs.push(response.data)
      } finally {
        this.loading = false
      }
    },
    async onSuccess() {
      this.loading = true
      try {
        const data = [] as SubRegionCrud[]
        const subregions = this.$refs.subregion as (Vue & {
          getData: () => SubRegionCrud[]
        })[]
        if (subregions) {
          subregions.forEach(subregion => {
            subregion.getData().forEach(item => {
              data.push(item)
            })
          })
        }
        const payload = this.crud
        if (!payload.agent) payload.agent = this.item.uuid
        payload.subregion_commissions = data

        const response = await createMessenger(payload)
        const item = this.item
        item.messenger_configs.push(response.data)

        this.$emit('new-item', item)
        this.$emit('input', false)
      } finally {
        this.loading = false
      }
    },
    onRegionsSelected(payload: Region[]): void {
      this.regions = payload
    },
    setAll() {
      const subregions = this.$refs.subregion as (Vue & {
        setAll: (value: number) => void
      })[]
      subregions[this.tabs].setAll(this.fixed_commission)
    },
    activeAll() {
      const subregions = this.$refs.subregion as (Vue & {
        activeAll: () => void
      })[]
      subregions[this.tabs].activeAll()
    },
    deactiveAll() {
      const subregions = this.$refs.subregion as (Vue & {
        deactiveAll: () => void
      })[]
      subregions[this.tabs].deactiveAll()
    },
    async checkConfig() {
      this.loadingConfig = true
      try {
        const response = await messengerConfigController.getter({
          agent__uuid: this.item.uuid,
          delivery_currency: this.crud.delivery_currency,
          limit: 1,
        })
        await this.$nextTick()
        if (response.data.results.length) {
          this.crud = response.data.results[0]
        } else {
          this.crud = {
            ...this.defaultCrud,
            delivery_currency: this.crud.delivery_currency,
            agent: this.item.uuid,
          }
        }
        const regions = this.crud.subregion_commissions.map(
          item => item.region || 0,
        )
        const regionDialog = this.$refs.regionDialog as Vue & {
          setRegions: (regions: number[]) => void
        }
        regionDialog.setRegions(regions)
      } finally {
        this.loadingConfig = false
      }
    },
    onButtonMounted() {
      if (this.mounted) return
      this.mounted = true
      this.checkConfig()
    },
  },
  watch: {
    async item() {
      this.checkConfig()
    },
    value(value) {
      if (value) {
        this.checkConfig()
      }
    },
    'crud.delivery_currency'() {
      this.checkConfig()
    },
  },
})
